export const API_HOST = 'https://api.treinadelta.com.br';
